module.exports = __webpack_public_path__ + "img/money.41fd98a1.svg";